import { apiSlice } from 'src/features/api/api-slice';
import { ApiResponse } from 'src/common/interfaces';
import { PathOutline } from 'src/common/interfaces/paths';
import { RTKQueryTag } from 'src/common/constants';

export const extendedApiSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getPathOutline: builder.query<ApiResponse<PathOutline>, string>({
      query: (pathCode) => ({
        url: `paths/outline?pathCode=${pathCode}`,
      }),
      providesTags: (result, error, pathCode) => [{ type: RTKQueryTag.PathOutline, id: pathCode }],
    }),
  }),
});

export const { useGetPathOutlineQuery } = extendedApiSlice;
